import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {TermsAndConditionsModel} from "../../../models/common/terms-and-conditions.model";
import {QuillEditorComponent} from "ngx-quill";
import {ContactPersonsComponent} from "../../form-fields/contact-persons/contact-persons.component";
import {BehaviorSubject} from "rxjs";
import {DepotMasterTab1} from "../../../models/Depot_Master_Model/depot-master-tab1";
import {MatSnackBar} from "@angular/material/snack-bar";
import {RequestApiService} from "../../../services/domain_code/request-api.service";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../services/auth.service";
import {ApiRoutes} from "../../../services/apiroutes";
import {WarningBoxComponent} from "../../dialog-box/warning-box/warning-box.component";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'logzy-vessel-movement-details',
    templateUrl: './vessel-movement-details.component.html',
    styleUrls: ['./vessel-movement-details.component.scss']
})
export class VesselMovementDetailsComponent implements OnInit {

    vessel: string = '';
    voyage: string = '';
    polEta: string = '';
    polEtd: string = '';
    podEta: string = '';
    vesselList: any[] = [];
    voyageList: any[] = [];
    errorObj: any = {};
    currentDate = new Date();
    disableSaveButton: boolean = false;
    isCustomer: boolean;
    movementDetails;

    constructor(private snackBar: MatSnackBar,
                public requestService: RequestApiService,
                private dialog: MatDialog, public authService: AuthService,
                private route: ActivatedRoute
    ) {
    }

    base_url = ApiRoutes.Location;

    loading: boolean = true;
    selectedCurrency = '';
    pickupLocationListUrl1 = '';
    transactionType: string | any = '';
    requestType: string = '';
    dev_value: string = '';
    requirementList: [] = [];

    ngOnInit(): void {
        this.isCustomer = this.authService.isCustomer();

        this.requirementList = [];
        this.pickupLocationListUrl1 = null;

        this.route.queryParams.subscribe(params => {
            if ('id' in params) {
                this.getRequestDetails(params['id']);
            }
        });


    }

    getRequestDetails(id) {
        this.requestService.getRequestDetailsById(id).subscribe({
            next: response => {
                this.requestService.selectedRequest = {...response};
                this.requirementList = this.requestService.selectedRequest.requirement;
                console.log('ngOnInit --------------------------> ', this.requestService.selectedRequest.booking);
                this.getMovementDetails(this.requestService.selectedRequest.booking);
            }
        });
    }

    openWarning(label: string, description, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {subTitle: label, parent: this, description: description, label1: action1, label2: action2}
        });
    }


    saveOrder() {
        if (this.vessel == '' || this.voyage == '' || this.polEta == '' || this.polEtd == '' || this.podEta == '') {
            this.openWarning('Please enter all values', '', '', 'I Understand');
        } else {
            this.disableSaveButton = true;
            let savePayload = {
                booking: this.requestService.selectedRequest.booking,
                vessel: this.vessel,
                voyage: this.voyage,
                pol_eta: this.polEta,
                pol_etd: this.polEtd,
                pod_eta: this.podEta,
                request: this.movementDetails?.request,
                request_type: this.movementDetails?.request_type?.id
            };

            this.requestService.postMovementDetails(savePayload).subscribe({
                next: response => {
                    this.snackBar.open('Data Saved Successfully', 'Close', {
                        verticalPosition: 'top',
                        duration: 3000,
                    });
                    console.log('postQuotations', response);
                    this.disableSaveButton = false;
                },
                error: err => {
                    this.snackBar.open('Something went wrong!! Please try again after sometime.', 'Close', {
                        verticalPosition: 'top',
                        duration: 5000,
                    });
                    this.disableSaveButton = false;
                }
            });
        }
    }

    dateChange(billed_from) {
        let valid_till = new Date(billed_from);
        valid_till.setDate(valid_till.getDate() + 14);
    }

    // Function to catch errors
    catchError(error) {
        if (error.status >= 500) {
            this.errorObj = {...error.error};
            console.log(error.status, error.statusText, error);
            console.debug("error object", this.errorObj);
            return error;
        } else if (error.status > 399 && error.status < 500) {
            this.errorObj = {...error.error};
            console.log(error.status, error.statusText, error);
            console.debug("error object", this.errorObj);
            return error;
        }
    }

    getMovementDetails(booking: string) {
        this.requestService.getMovementDetails(booking).subscribe({
            next: response => {
                this.movementDetails = response;
                // console.log('getMovementDetails', this.movementDetails);
                if (this.movementDetails?.vessel != null) {
                    this.vessel = this.movementDetails?.vessel;
                    this.voyage = this.movementDetails?.voyage;
                    this.polEta = this.movementDetails?.pol_eta;
                    this.podEta = this.movementDetails?.pod_eta;
                    this.polEtd = this.movementDetails?.pol_etd;
                }
            },
            error: err => {
                this.snackBar.open('Something went wrong!! Please try again after sometime.', 'Close', {
                    verticalPosition: 'top',
                    duration: 5000,
                });
            }
        });
    }
}
